export const setGlobalCSSVariable = (variable: string, value: string | null) => {
  document.documentElement.style.setProperty(variable, value);
};
